import type { KubernetesMaintenance } from "@warrenio/api-spec/spec.oats.gen";
import invariant from "tiny-invariant";

interface StatusType {
    id: string;
    title: string;
}

export const startTimes: StatusType[] = [
    { id: "010000", title: "1:00" },
    { id: "020000", title: "2:00" },
    { id: "030000", title: "3:00" },
    { id: "040000", title: "4:00" },
    { id: "050000", title: "5:00" },
    { id: "060000", title: "6:00" },
    { id: "070000", title: "7:00" },
    { id: "080000", title: "8:00" },
    { id: "090000", title: "9:00" },
    { id: "100000", title: "10:00" },
    { id: "110000", title: "11:00" },
    { id: "120000", title: "12:00" },
    { id: "130000", title: "13:00" },
    { id: "140000", title: "14:00" },
    { id: "150000", title: "15:00" },
    { id: "160000", title: "16:00" },
    { id: "170000", title: "17:00" },
    { id: "180000", title: "18:00" },
    { id: "190000", title: "19:00" },
    { id: "200000", title: "20:00" },
    { id: "210000", title: "21:00" },
    { id: "220000", title: "22:00" },
    { id: "230000", title: "23:00" },
    { id: "000000", title: "00:00" },
];

export const timeZones: StatusType[] = [
    { id: "-1200", title: "-12:00" },
    { id: "-1100", title: "-11:00" },
    { id: "-1000", title: "-10:00" },
    { id: "-0900", title: "-9:00" },
    { id: "-0800", title: "-8:00" },
    { id: "-0700", title: "-7:00" },
    { id: "-0600", title: "-6:00" },
    { id: "-0500", title: "-5:00" },
    { id: "-0400", title: "-4:00" },
    { id: "-0300", title: "-3:00" },
    { id: "-0200", title: "-2:00" },
    { id: "-0100", title: "-1:00" },
    { id: "+0000", title: "GMT" },
    { id: "+0100", title: "+1:00" },
    { id: "+0200", title: "+2:00" },
    { id: "+0300", title: "+3:00" },
    { id: "+0400", title: "+4:00" },
    { id: "+0500", title: "+5:00" },
    { id: "+0600", title: "+6:00" },
    { id: "+0700", title: "+7:00" },
    { id: "+0800", title: "+8:00" },
    { id: "+0900", title: "+9:00" },
    { id: "+1000", title: "+10:00" },
    { id: "+1100", title: "+11:00" },
    { id: "+1200", title: "+12:00" },
];

export function getFormattedMaintenance(
    begin: string,
    timeZone: string,
    machineImageVersion: boolean,
    kubernetesVersion: boolean,
): KubernetesMaintenance {
    const endTime = getEndHour(begin);
    invariant(endTime.length === 2);

    return {
        autoUpdate: {
            kubernetesVersion: kubernetesVersion,
            machineImageVersion: machineImageVersion,
        },
        timeWindow: {
            begin: begin + timeZone,
            end: `${endTime}0000${timeZone}`,
        },
    };
}

function getEndHour(begin: string) {
    const beginInteger = parseInt(begin.slice(0, 2), 10);
    const nextHour = (beginInteger + 1) % 24;
    return nextHour.toString().padStart(2, "0");
}
